exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container .filter-container[data-v-0d4a7bee]{padding-bottom:10px}.app-container .filter-container .filter-item[data-v-0d4a7bee]{display:inline-block;vertical-align:middle;margin-bottom:10px}", ""]);

// exports
